import { createKeyDownFilter } from './keyboard';

export const numbersOnlyKeyDown = (event: React.KeyboardEvent<HTMLInputElement>): void => {
  const filter = createKeyDownFilter(/[0-9.]/);
  filter(event);
};

export const numbersOnlyWithoutDotKeyDown = (
  event: React.KeyboardEvent<HTMLInputElement>
): void => {
  const filter = createKeyDownFilter(/[0-9]/);
  filter(event);
};
